// src/components/SideDrawer.jsx
import { useEffect } from "react";
import "./side-drawer.css";
import NotificationsFeed from "../pages/NotificationsFeed";

export default function SideDrawer({ open, onClose, title, children }) {
  // close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // basic body scroll lock while open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <>
      <div
        className={`sd-backdrop ${open ? "is-open" : ""}`}
        onClick={handleBackdrop}
        aria-hidden={!open}
      />
      <aside
        className={`sd-drawer ${open ? "is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={title || "Panel"}
      >
        <header className="sd-header">
          <h3 className="sd-title">{title}</h3>
          <button className="sd-close" onClick={onClose} aria-label="Close">✕</button>
        </header>

        <div className="sd-content">
          {/* {children /* ← your NotificationsFeed goes right here */} 
          <NotificationsFeed />
        </div>
      </aside>
    </>
  );
}
